/**
 * 日期格式化工具
 */

/**
 * 格式化日期时间
 * @param {Date|string|number} date 日期对象、日期字符串或时间戳
 * @param {string} format 格式化模板，默认为'yyyy-MM-dd HH:mm:ss'
 * @returns {string} 格式化后的日期字符串
 */
export function formatDate(date, format = 'yyyy-MM-dd HH:mm:ss') {
  // 处理输入参数
  if (!date) return ''
  
  // 转换为Date对象
  const d = typeof date === 'object' ? date : new Date(date)
  
  // 检查日期是否有效
  if (isNaN(d.getTime())) return ''
  
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = d.getDate()
  const hours = d.getHours()
  const minutes = d.getMinutes()
  const seconds = d.getSeconds()
  
  // 补零函数
  const pad = (num) => num.toString().padStart(2, '0')
  
  // 替换格式化模板
  return format
    .replace('yyyy', year)
    .replace('MM', pad(month))
    .replace('dd', pad(day))
    .replace('HH', pad(hours))
    .replace('mm', pad(minutes))
    .replace('ss', pad(seconds))
}

/**
 * 获取当前时间戳（毫秒）
 * @returns {number} 当前时间戳
 */
export function getTimestamp() {
  return Date.now()
}

/**
 * 格式化时间戳为日期字符串
 * @param {number} timestamp 时间戳（毫秒）
 * @param {string} format 格式化模板
 * @returns {string} 格式化后的日期字符串
 */
export function formatTimestamp(timestamp, format = 'yyyy-MM-dd HH:mm:ss') {
  return formatDate(new Date(timestamp), format)
}

/**
 * 获取相对时间描述（例如：3分钟前、2小时前、1天前）
 * @param {Date|string|number} date 日期对象、日期字符串或时间戳
 * @returns {string} 相对时间描述
 */
export function getRelativeTime(date) {
  if (!date) return ''
  
  const d = typeof date === 'object' ? date : new Date(date)
  if (isNaN(d.getTime())) return ''
  
  const now = new Date()
  const diff = now.getTime() - d.getTime()
  
  const minute = 60 * 1000
  const hour = 60 * minute
  const day = 24 * hour
  const week = 7 * day
  const month = 30 * day
  const year = 365 * day
  
  if (diff < minute) {
    return '刚刚'
  } else if (diff < hour) {
    return `${Math.floor(diff / minute)}分钟前`
  } else if (diff < day) {
    return `${Math.floor(diff / hour)}小时前`
  } else if (diff < week) {
    return `${Math.floor(diff / day)}天前`
  } else if (diff < month) {
    return `${Math.floor(diff / week)}周前`
  } else if (diff < year) {
    return `${Math.floor(diff / month)}个月前`
  } else {
    return `${Math.floor(diff / year)}年前`
  }
}